export default (context, row) => {
    if (context.state.extendedListView) {
        if (context.state.currentExtendedRow === _.get(row, context.state.identifier_field)) {
            context.state.currentExtendedRow = null;
        } else {
            context.state.currentExtendedRow = _.get(row, context.state.identifier_field);
        }
    } else {
        const action = context.getters.mainRowAction;
        if (action) {
            return context.dispatch('clicked', {action: action, row: row})
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/clicked-main-row.js